<template>
  <div class="tc-container">
      <div class="tc-content text-center" 
          :style="'background: url('+row.image3+')'">
        <div class="title white-color" v-html="row.title3"></div>
        <div class="bg-title white-color text-uppercase" v-html="row.body3"></div>
        <router-link v-if="row.button3" 
                    :to="row.redirect3" 
                    :style="'background:'+row.bgColor3" 
                    class="tc-btn" 
                    v-html="row.button3">
        </router-link>
      </div>
  </div>
</template>

<style scoped>
.tc-container {
  margin-bottom: 0.7rem;
}
.tc-content {
  padding: 50px 0 70px;
  background-size: cover !important;
}
.title {
  font-size: 34px;
  margin-bottom: 130px;
}
.bg-title {
  font-size: 70px;
  margin-bottom: 50px;
}
.tc-btn {
  background: #04CC88;
  color: #fff;
  font-size: 20px;
  padding: 9px 30px;
  line-height: 1;
  display: inline-block;
}
.tc-btn:hover {
  opacity: 0.8;
}
.tc-btn:active {
  opacity: 0.6;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .tc-content {
    height: auto;
    padding: 70px 20px;
  }
  .title {
    font-size: 27px;
    margin-bottom: 30px;
  }
  .bg-title {
    font-size: 50px;
    margin-bottom: 50px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .tc-content {
    padding: 80px 30px;
    height: auto;
  }
  .title {
    margin-bottom: 30px;
  }
  .bg-title {
    font-size: 55px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
